// extracted by mini-css-extract-plugin
module.exports = {"AssistantLevelBadge":"AssistantLevelBadge_AssistantLevelBadge__2iglD","Badge":"AssistantLevelBadge_Badge__1J8sA","Circle":"AssistantLevelBadge_Circle__2b9Gx"};